var Connection = require('connection');


var ConnectionList = Backbone.Collection.extend({
    model: Connection,
    comparator: function (connection) {
        return connection.getOrder();
    },
    initialize: function (models, options) {
        this.session = options.session;
    },
    saveOrder: function () {
        this.sort();
        this.session.post('reorder-connections', {
            cids: this.pluck('cid').join(',')
        });
    },
    move: function (connection, up) {
        var index = this.indexOf(connection);
        if (up) {
            index--;
        } else {
            index++;
        }
        if (index < 0 || index >= this.length) {
            debug.warn('Tried to move a connection out of bounds', index, connection);
            return;
        }
        this.moveTo(connection, index);
    },
    moveTo: function (connection, at) {
        this.remove(connection, {silent: true});
        this.add(connection, {at: at, silent: true});
        this.each(function (conn, i) {
            conn.setOrder(i+1);
        });
        this.saveOrder();
        this.trigger('moveTo', connection, at);
    },
    orderChanged: function (order) {
        _.each(order, function (cid, i) {
            var conn = this.get(cid);
            conn.setOrder(i + 1);
            this.trigger('moveTo', conn, i);
        }, this);
        this.sort();
    }
});


module.exports = ConnectionList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/connectionlist.js
// module id = 8Gq8
// module chunks = 1